import React from "react";

import ImageItem from "./components/image-item";

const ImagePickerDisplay = ({ value, provider }) => {
    if (!value) {
        return null;
    }

    const selectedImageItems = value.map((item) => {
        return <ImageItem key={`selected_${item.value}`} provider={provider} data={item} />;
    });

    const display = typeof value === "string" ? value : selectedImageItems;

    return (
        <div className="image-picker">
            <div className="review-images">{display}</div>
        </div>
    );
};

export default ImagePickerDisplay;
